const refs = {
  form: document.querySelector('.hero-search-form'),
  input: document.querySelector('.hero-form-input'),
  list: document.querySelector('.hero-search-cards'),
  searchButtonWrapper: document.querySelector('.button-search-wrapper-js'),
  buttonSpan: document.querySelector('.button-search-span-js'),
  searchDropdown: document.querySelector('.button-dropdown-js'),
  listPag: document.querySelector('.pagination-list'),
  titileCocktail: document.querySelector('.cocktail-main-title'),
};

export default refs;
